import { RootState } from 'constants/interfaces'
import { DEVICE_TYPES } from 'constants/UI'
import useWindowDimensions from 'hooks/useWindowDimensions'
import React, { useState } from 'react'
import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { UserModalsProvider } from './UserModalsManagerContext'
import { UsersBoardContent } from './UsersBoardContent'

const UsersBoard: React.FC = () => {
  const {
    config: { retail_users },
  } = useSelector((state: RootState) => state.config)
  const { windowWidth } = useWindowDimensions()

  const [viewMode, setViewMode] = useState<'grid' | 'table'>('table')

  const [searchQuery, setSearchQuery] = useState('')

  const usersList = useMemo(() => {
    if (searchQuery === '') return retail_users
    return retail_users.filter((user) =>
      [user.first_name, user.last_name, user.uid?.toString(), user.sec_uid, user.desc]
        .filter(Boolean)
        .some((val) => val?.toLowerCase().includes(searchQuery.toLowerCase()))
    )
  }, [retail_users, searchQuery])

  useEffect(() => {
    if (DEVICE_TYPES.MOBILE(windowWidth)) {
      setViewMode('grid')
    }
  }, [windowWidth])

  return (
    <UserModalsProvider>
      <UsersBoardContent
        users={usersList}
        viewMode={viewMode}
        onChangeViewMode={() => setViewMode(viewMode === 'grid' ? 'table' : 'grid')}
        searchQuery={searchQuery}
        onSearch={setSearchQuery}
      />
    </UserModalsProvider>
  )
}

export default UsersBoard
